const { loadScript, loadStyle } = require('./util/loadDependencies');

export default (jsBasePath) => jQuery(($) => {
	const triggerLightbox = () => {
		$('.lightbox').modaal({
			type: 'image',
		});
	};

	loadStyle(`${jsBasePath}../vendor/modaal/css/modaal.min.css`);
	loadScript(`${jsBasePath}../vendor/modaal/js/modaal.min.js`, triggerLightbox);
});
